import React from 'react'
import AddCondition from './AddCondition'

const Terms = (props) => {

	return (<AddCondition {...props} conditions={props.data.conditions}/>)

}

export default Terms
